import { createSaga } from './saga-helpers';

import * as Api from '../api/forms-api';

const watchGetForms = createSaga({
    type: 'FORMS_FETCH',
    fn: Api.fetchForms,
    args: action => [action.payload],
    successPayload: ({ items, hasMore } = {}, action) => ({
        forms: items,
        hasMore,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchCreateForm = createSaga({
    type: 'FORM_CREATE',
    fn: Api.createForm,
    args: action => [action.payload.form],
    successPayload: ({ id: formId }, action) => ({
        formId,
        fragment: action.payload.form
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        fragment: action.payload.form
    })
});

const watchGetForm = createSaga({
    type: 'FORM_FETCH',
    fn: Api.fetchForm,
    args: action => [action.payload.formId],
    successPayload: form => ({ form })
});

const watchUpdateForm = createSaga({
    type: 'FORM_UPDATE',
    fn: Api.updateForm,
    args: action => [action.payload.formId, action.payload.formProps],
    successPayload: form => ({ form })
});

const watchRemoveForm = createSaga({
    type: 'FORM_REMOVE',
    fn: Api.removeForm,
    args: action => [action.payload.formId]
});

const sagas = [watchGetForms, watchCreateForm, watchGetForm, watchUpdateForm, watchRemoveForm];

export default sagas;
